var firebase = require('firebase');
firebase.database.enableLogging(true);

// test
/*var app = firebase.initializeApp({
    apiKey: "AIzaSyB57aQRe9rKl-0vXkmX-TNHQhOlTZ4sZwk",
    authDomain: "ajato-e2d54.firebaseapp.com",
    databaseURL: "https://ajato-e2d54.firebaseio.com",
    storageBucket: "ajato-e2d54.appspot.com",
    messagingSenderId: "838262132868"
});*/

// prod
var app = firebase.initializeApp({
    apiKey: "AIzaSyAb6Vrikow2WVyLFs3C5_LbpWM7v0c8Z_o",
    authDomain: "ajato-29abc.firebaseapp.com",
    databaseURL: "https://ajato-29abc.firebaseio.com",
    storageBucket: "ajato-29abc.appspot.com",
    messagingSenderId: "980024883694"
});

module.exports = {
	fbAuth: app.auth(),
	fbDb: app.database(),
    fbStorage: app.storage()
};


// WEBPACK FOOTER //
// ./src/firebase/index.js